export default __webpack_public_path__ + "static/media/01_katerinakhaidukova.61b52b4e.jpg";